import { useEffect, useState } from 'react'
// Initialize state with undefined width/height so server and client renders match
// Source: https://joshwcomeau.com/react/the-perils-of-rehydration/
const initialState = { width: undefined, height: undefined }

export default function useWindowSize () {
  const [, setWindowSize] = useState({ ...initialState })

  useEffect(() => {
    // Handler to call on window resize
    function onResize () {
      // Set window width/height to state
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      })
    }
    // add event listener
    window.addEventListener('resize', onResize)
    // invoke handler immediately ensuring state updates with initial window size
    onResize()
    // remove event listener on cleanup (preventing memory leaks)
    return () => window.removeEventListener('resize', onResize)
  }, [])
}
